import { useId, type ReactNode } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { buttonClass } from "@/components/buttonStyles";

// The one question before a broker's entries are thrown away (BRK-S300): a
// wizard toggle switched off over filled rows, a row removed with rows of its
// own, an owner removed from a Surety account with their spouse (BRK-S408).
// Outside `base/wizard` since BRK-S408, so surety can ask it too without
// importing the commercial wizard base (BRK-S312). The question is the
// dialog's name; the safe answer is listed first and the destructive one
// carries the view's accent. A question that needs a sentence of context — the
// submission's Advance-redirect confirm (BRK-S422) — passes it as children.
export function ConfirmDialog({
  open,
  question,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  children,
}: {
  open: boolean;
  question: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  /** Optional context under the question. */
  children?: ReactNode;
}) {
  const titleId = useId();
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby={titleId}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id={titleId}>{question}</DialogTitle>
      {children && <DialogContent>{children}</DialogContent>}
      <DialogActions>
        <button
          type="button"
          onClick={onCancel}
          className={buttonClass({ variant: "secondary" })}
        >
          {cancelLabel}
        </button>
        <button type="button" onClick={onConfirm} className={buttonClass()}>
          {confirmLabel}
        </button>
      </DialogActions>
    </Dialog>
  );
}
